module.exports = __webpack_public_path__ + "img/caja2.14768c4a.png";